import React, {useState} from "react";

const DownloadDocumentButton = ({
        onClick,
        text,
        disabled = false,
        loading = false,
        hasData = true }) => {

  const [isDownloading, setIsDownloading] = useState(false);

  const handleClick = async (e) => {
    if (disabled || !hasData || loading) return;
    
    setIsDownloading(true);
    try {
      await onClick(e);
    } finally {
      setIsDownloading(false);
    }
  };

    return(

        <button 
        onClick={handleClick}
        disabled={disabled || loading || !hasData || isDownloading}
        className={`flex items-center justify-center gap-2 
            ${disabled || !hasData || loading || isDownloading ? 'text-gray cursor-not-allowed' : 'text-blue hover:underline cursor-pointer '}
        `}>
        <p className="text-xs md:text-sm font-itcmedium">
          {isDownloading ? 'Descargando...' : (loading ? 'Descargando...' : text)}
        </p>
        <svg className="rotate-180" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_18127)">
            <path d="M16.4405 15.1001C20.0405 14.7901 21.5105 12.9401 21.5105 8.8901V8.7601C21.5105 4.2901 19.7205 2.5001 15.2505 2.5001H8.74047C4.27047 2.5001 2.48047 4.2901 2.48047 8.7601V8.8901C2.48047 12.9101 3.93047 14.7601 7.47047 15.0901"
            stroke={`${disabled || !hasData ? '#808080' : '#007696'}`} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 22V9.12"
            stroke={`${disabled || !hasData ? '#808080' : '#007696'}`} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.3504 11.3496L12.0004 7.99961L8.65039 11.3496"
            stroke={`${disabled || !hasData ? '#808080' : '#007696'}`} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_1_18127">
            <rect width="24" height="24" fill="white" transform="matrix(1 0 0 -1 0 24)"/>
            </clipPath>
            </defs>
        </svg>
    </button>
    );
};

export default DownloadDocumentButton;